import { createSelector } from 'reselect'

const selectGuide = state => state.guides

const selectGuides = createSelector(
  selectGuide,
  guides => guides.guides
)

const selectGuidesFetching = createSelector(
  selectGuide,
  guides => guides.isFetching
)

const selectCurrentPhoneGuidesId = createSelector(
  selectGuide,
  guides => guides.currentPhoneId
)

const selectActiveGuide = createSelector(
  selectGuide,
  guides => guides.activeGuide
)

export {
  selectGuides,
  selectGuidesFetching,
  selectCurrentPhoneGuidesId,
  selectActiveGuide
}



// WEBPACK FOOTER //
// ./src/containers/Guides/selectors.js